// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/fonts/avenir-black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/assets/fonts/avenir-black-oblique.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/assets/fonts/avenir-book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/assets/fonts/avenir-book-oblique.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/assets/fonts/avenir-heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../public/assets/fonts/avenir-heavy-oblique.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../public/assets/fonts/avenir-light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../public/assets/fonts/avenir-light-oblique.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../public/assets/fonts/avenir-medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../public/assets/fonts/avenir-medium-oblique.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../public/assets/fonts/avenir-oblique.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../public/assets/fonts/avenir-roman.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'avenir-black';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}
@font-face {
  font-family: 'avenir-black-oblique';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
@font-face {
  font-family: 'avenir-book';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}
@font-face {
  font-family: 'avenir-book-oblique';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
@font-face {
  font-family: 'avenir-heavy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}
@font-face {
  font-family: 'avenir-heavy-oblique';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}
@font-face {
  font-family: 'avenir-light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}
@font-face {
  font-family: 'avenir-light-oblique';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
}
@font-face {
  font-family: 'avenir-medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}
@font-face {
  font-family: 'avenir-medium-oblique';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
}
@font-face {
  font-family: 'avenir-oblique';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype');
}
@font-face {
  font-family: 'avenir-roman';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
}
h1 {
  font-family: avenir-book, sans-serif;
  font-size: 28px;
  line-height: 125%;
}
h1.h1-small {
  font-size: 24px;
  letter-spacing: 0;
}
h2 {
  font-family: avenir-medium, sans-serif;
  font-size: 20px;
  letter-spacing: 0.2px;
  line-height: 150%;
}
h3 {
  font-family: avenir-medium, sans-serif;
  font-size: 18px;
  letter-spacing: 0.2px;
  line-height: 150%;
}
h4 {
  font-family: avenir-heavy, sans-serif;
  font-size: 16px;
  letter-spacing: 0.4%;
  line-height: 24px;
}
h4.h4-small {
  font-size: 14px;
}
body {
  font-family: avenir-book, sans-serif;
  font-size: 16px;
  letter-spacing: 0.25px;
  line-height: 24px;
}
body.-small {
  font-size: 14px;
}
.body-small {
  font-family: avenir-book, sans-serif;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 24px;
}
.button-label {
  font-family: avenir, sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 24px;
}
.label-large {
  font-family: avenir-book, sans-serif;
  font-size: 14px;
  letter-spacing: 0.1%;
}
.label-medium {
  font-family: avenir-book, sans-serif;
  font-size: 12px;
  letter-spacing: 0.4%;
}
.label-small {
  font-family: avenir-book, sans-serif;
  font-size: 10px;
  letter-spacing: 1%;
}
.link {
  font-family: avenir-heavy, sans-serif;
  font-size: 16px;
  letter-spacing: 0.25px;
  line-height: 24px;
  color: var(--blue);
}
.link.small {
  font-size: 14px;
}
.monospace {
  font-family: 'Major Mono Display', monospace;
  font-size: 12px;
  line-height: 21px;
  letter-spacing: 0.25px;
}
.subheadline {
  font-family: avenir-medium, sans-serif;
  font-size: 24px;
  letter-spacing: 0.2px;
  line-height: 150%;
}
.subheadline.small {
  font-size: 20px;
}
/** Page setup **/
@page {
  size: auto;
  margin: 0;
}
/** Media Queries **/
@media print {
  .do-not-print {
    display: none !important;
  }
}
@media only screen and (min-width: 601px) {
  .hide-over-601 {
    display: none !important;
  }
  .more-light-gray-background-on-hover:hover {
    background-color: rgba(178, 178, 178, 0.15) !important;
  }
}
@media only screen and (max-width: 800px) {
  .border-bottom-under-800 {
    border-bottom: 1px solid #f0f0f0;
  }
  .feed-topbar,
  .show-block-under-800,
  .show-flex-under-800,
  .show-under-800 {
    display: block !important;
  }
  .hide-under-800,
  .show-flex-over-801,
  .show-over-801 {
    display: none !important;
  }
  .hide-side-margins-under-800 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .inbox-spool-container,
  .messages-max-width,
  .max-width-under-800,
  .width-100-under-800 {
    max-width: 100% !important;
  }
  .flex-column-under-800 {
    flex-direction: column;
  }
  .font-18-under-800 {
    font-size: 18px !important;
  }
  .margin-0-under-800,
  .margin-left-0-under-800,
  .margin-top-under-800,
  .top-50-under-800 {
    margin: 0 !important;
    top: 50px !important;
  }
  .margin-right-20-under-800 {
    margin-right: 20px !important;
  }
  .padding-bottom-under-800,
  .padding-under-800 {
    padding: 15px 20px !important;
  }
  .top-flush {
    top: var(--top-height);
  }
}
/** General Styles **/
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.block {
  display: block;
}
.blue-text {
  color: #0894CF;
}
.box-shadow-style {
  box-shadow: 1px 1px 8px 0px #e7e7e7;
}
.carbon-text {
  color: #2A2A2A;
}
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 18px;
  background: none;
  border: none;
  cursor: pointer;
}
.column {
  flex-direction: column;
}
.double-blue-border-on-focus {
  border: 2px solid transparent;
  position: relative;
}
.double-blue-border-on-focus:focus-visible {
  border: 2px solid #ffffff !important;
  outline: 2px solid #0894cf !important;
  outline-offset: 2px;
  box-shadow: 0 0 0 2px #98e0ff, 0 0 0 4px #98e0ff;
  z-index: 1;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flex,
.flex-grow,
.flex-v-align,
.flex-h-align,
.flex-vh-align {
  display: flex;
}
.flex-end {
  justify-content: flex-end;
}
.flex-grow {
  flex-grow: 1;
}
.flex-v-align {
  align-items: center;
}
.flex-h-align {
  justify-content: center;
}
.flex-vh-align {
  align-items: center;
  justify-content: center;
}
.gradient {
  background: linear-gradient(to right, #ED1C24, #27AAE1);
}
.gray-on-hover {
  cursor: pointer;
  transition: color 0.3s ease-in-out;
}
.gray-on-hover:hover {
  color: var(--steel) !important;
}
.gray-background-on-hover {
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}
.gray-background-on-hover:hover {
  background-color: var(--lightoffwhite) !important;
}
.light-gray-background-on-hover {
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}
.light-gray-background-on-hover:hover {
  background-color: var(--lightgrey) !important;
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
}
.input-label {
  color: #2A2A2A;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.25px;
}
.light-blue-background-on-hover {
  transition: background-color 0.3s ease-in-out;
}
.light-blue-background-on-hover:hover {
  background-color: #e0f3fb !important;
}
.light-blue-border-on-hover {
  transition: border-color 0.3s ease-in-out;
}
.light-blue-border-on-hover:hover {
  border: 1px solid #0894CF !important;
  box-shadow: 0 0px 4px 0px #0894cf;
}
.thick-light-blue-border-on-hover {
  position: relative;
}
.thick-light-blue-border-on-hover:hover {
  /* When hovering this element specifically (not when a child with the same class is hovered) */
}
.thick-light-blue-border-on-hover:hover:not(:has(.thick-light-blue-border-on-hover:hover)) {
  border: 2px solid var(--blue) !important;
  box-shadow: 0 0px 4px 0px #0894cf;
  background-color: var(--lightoffwhite);
  /* Show icons only when this specific element is being hovered */
}
.thick-light-blue-border-on-hover:hover:not(:has(.thick-light-blue-border-on-hover:hover)) > .hover-icons {
  display: flex;
}
.thick-light-blue-border-on-hover .hover-icons {
  display: none;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  gap: 8px;
}
.selected {
  border: 2px solid #0894CF !important;
  box-shadow: 0 0px 4px 0px #0894cf;
}
.selected > .hover-icons {
  display: flex !important;
}
.mapboxgl-ctrl-2d {
  background-image: url('https://s3-us-east-2.amazonaws.com/polimorphic-sha256/59422fb1d0b22010cf57ab619138a0af9687020619d2188df067515434259fb1/2d.svg');
  background-size: cover;
}
.mapboxgl-ctrl-3d {
  background-image: url('https://s3-us-east-2.amazonaws.com/polimorphic-sha256/d837050af2fa0bc0e4844304d69dbe8dab10b547195fd83bf93af7e683a1a791/3d.svg');
  background-size: cover;
}
.mapboxgl-ctrl-attrib.mapboxgl-compact {
  display: none !important;
}
.mapboxgl-ctrl-logo {
  display: none !important;
}
.mapboxgl-ctrl-satellite {
  background-image: url('https://s3-us-east-2.amazonaws.com/polimorphic-sha256/241018ee4ec04017e4e40d9e892ef80b24e19c73982b5a0d264cc2a1f328ece1/satellite.svg');
  background-size: cover;
}
.mapboxgl-ctrl-street {
  background-image: url('https://s3-us-east-2.amazonaws.com/polimorphic-sha256/ee4a715ad3d9692c9820758b4315aa3075e9feeabbafab380001bcc7e3b33593/map.svg');
  background-size: cover;
}
.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1001;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1300;
}
.overflow-vertical-style {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.pointer {
  cursor: pointer;
}
.sidebar:hover {
  max-width: 250px !important;
  width: 250px !important;
}
.sidebar:hover .sidebar-text {
  display: block !important;
}
.sidebar-menu-item1 {
  border-radius: 5px;
  cursor: pointer;
  padding: 10px 15px;
}
.sidebar-menu-item1-icon {
  margin-right: 15px;
}
.sidebar-menu-item1.active {
  background-color: rgba(178, 178, 178, 0.15);
}
.sidebar-menu-item1:hover {
  background-color: rgba(178, 178, 178, 0.15);
}
.sticky {
  position: sticky;
  position: -webkit-sticky;
}
.textCenter {
  text-align: center;
}
.transitionStyle {
  transition: 200ms ease-in;
}
.wrap {
  flex-wrap: wrap;
  row-gap: 16px;
}
.styled-links a {
  color: #0894CF;
}
.styled-links a:hover {
  text-decoration: underline;
}
.reset {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: none;
  border: 0;
  box-sizing: border-box;
  color: inherit;
  font: inherit;
  font-size: 100%;
  margin: 0;
  outline: none;
  padding: 0;
  text-decoration: none;
  vertical-align: baseline;
}
* {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: none;
  border: 0;
  box-sizing: border-box;
  color: inherit;
  font: inherit;
  font-size: 100%;
  margin: 0;
  outline: none;
  padding: 0;
  text-decoration: none;
  vertical-align: baseline;
}
:root {
  --inner-height: 100vh;
  --blue: #0894CF;
  --paleblue: #E6F4FA;
  --black: #000000;
  --black02: #D9D9D9;
  --green: #009C6D;
  --green02: #CCEBE2;
  --red: #ED1C24;
  --orange: #FF6E3C;
  --purple: #DE7DA5;
  --pink: #EE2A7B;
  --pink02: #FCD4E5;
  --teal: #00A296;
  --teal02: #CCEDEA;
  --highlightyellow: #FFF8DF;
  --white: #FFFFFF;
  --lightoffwhite: #F8F8F8;
  --offwhite: #F0F0F0;
  --mist: #F7FAFC;
  --palepeach: #FFF1EC;
  --carbon: #2A2A2A;
  --lightcarbon: #4A4A4A;
  --titanium: #666666;
  --steel: #888888;
  --grey: #BBBBBB;
  --lightgrey: #DDDDDD;
  --backgroundgreen: rgba(0, 131, 92, 0.1);
  --textgreen: #00835c;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section {
  display: block;
}
blockquote,
q {
  quotes: none;
}
del,
s {
  text-decoration: line-through;
}
em {
  font-style: italic;
}
input::-webkit-search-decoration {
  -webkit-appearance: none;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
input[type='number'].form-disable-spinner {
  -moz-appearance: textfield;
}
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
ol,
ul {
  list-style-position: inside;
}
::placeholder {
  color: #bbbbbb;
  opacity: 1;
}
progress {
  background-color: #eee;
  border-radius: 5px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25) inset;
}
progress::-webkit-progress-bar {
  background-color: #e0e0e0;
  border-radius: 4px;
}
progress.progress-blue::-webkit-progress-value {
  background-color: #0894CF;
  border-radius: 4px;
}
progress.progress-blue::-moz-progress-bar {
  background-color: #0894CF;
  border-radius: 4px;
}
progress.progress-green::-webkit-progress-value {
  background-color: #009C6D;
  border-radius: 4px;
}
progress.progress-green::-moz-progress-bar {
  background-color: #009C6D;
  border-radius: 4px;
}
progress[value]::-webkit-progress-value::before,
progress[value]::-moz-progress-value::before {
  position: absolute;
  right: 0;
  top: -125%;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
u {
  text-decoration: underline;
}
/** RESPONSIVE DESIGN **/
@media only screen and (min-width: 1280px) {
  .hide-over-1280 {
    display: none !important;
  }
}
@media only screen and (min-width: 1201px) {
  .show-under-1200 {
    display: none;
  }
}
@media only screen and (min-width: 1024px) {
  .hide-over-1024 {
    display: none !important;
  }
}
@media only screen and (min-width: 801px) {
  .hide-over-801 {
    display: none;
  }
  .full-max-height-over-801 {
    max-height: calc(var(--inner-height)) !important;
  }
  .full-height-over-801 {
    height: calc(var(--inner-height)) !important;
  }
}
@media only screen and (min-width: 800px) {
  .hide-over-800 {
    display: none;
  }
  .font-over-800 {
    font-size: 48px !important;
    margin-left: 22% !important;
  }
}
@media only screen and (min-width: 400px) {
  .nowrap-over-400 {
    white-space: nowrap;
  }
  .hide-over-400 {
    display: none !important;
  }
}
@media only screen and (max-width: 1440px) {
  .show-over-1440 {
    display: none;
  }
  .landing-card {
    border-radius: 10px;
  }
}
@media only screen and (min-width: 1367px) {
  .show-over-1367 {
    display: block;
  }
  .max-width-660-over-1367 {
    max-width: 660px !important;
  }
}
@media only screen and (max-width: 1366px) {
  .show-over-1367 {
    display: none;
  }
}
@media only screen and (min-width: 1280px) {
  .messages-max-width {
    max-width: calc(100vw - 640px) !important;
  }
  .show-over-1280 {
    display: block;
  }
}
@media only screen and (max-width: 1279px) {
  .show-over-1280 {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  .feed-right-sidebar {
    display: none;
  }
  .hide-under-1200 {
    display: none;
  }
  .feed-left-sidebar {
    display: none;
  }
}
@media only screen and (min-width: 1100px) {
  .show-under-1099 {
    display: none !important;
  }
  .max-width-minus-630-over-1100 {
    max-width: calc(100% - 630px) !important;
  }
  .max-width-minus-385-over-1100 {
    max-width: calc(100% - 385px) !important;
  }
}
@media only screen and (max-width: 1099px) {
  .full-height-under-1100 {
    height: 100% !important;
  }
  .margin-under-1100 {
    margin: 0 auto;
  }
  .no-flex-under-1100 {
    display: block !important;
  }
  .show-over-1100 {
    display: none !important;
  }
  .flex-grow-under-1099 {
    flex-grow: 1;
  }
  .flex-wrap-under-1099 {
    flex-wrap: wrap;
  }
}
@media only screen and (min-width: 601px) and (max-width: 1099px) {
  .width-under-1100 {
    width: 550px !important;
  }
}
@media only screen and (min-width: 601px) {
  .hide-over-601 {
    display: none !important;
  }
  .more-light-gray-background-on-hover:hover {
    background-color: rgba(178, 178, 178, 0.15) !important;
  }
}
@media only screen and (max-width: 1024px) {
  .hide-under-1024 {
    display: none !important;
  }
  .show-under-1024 {
    display: block !important;
  }
  .show-flex-under-1024 {
    display: flex !important;
  }
}
@media only screen and (min-width: 1024px) {
  .show-flex-under-1023 {
    display: none;
  }
  .show-flex-over-1024 {
    display: flex;
  }
}
@media only screen and (max-width: 1023px) {
  .show-flex-under-1023 {
    display: flex;
  }
  .show-flex-over-1024 {
    display: none;
  }
}
@media only screen and (min-width: 990px) {
  .show-under-989 {
    display: none;
  }
  .show-over-990 {
    display: block;
  }
  .width-over-990 {
    width: 620px;
    min-width: 620px;
  }
}
@media only screen and (max-width: 989px) {
  .show-over-990 {
    display: none;
  }
  .show-under-989 {
    display: block;
  }
  .side-margin-auto-under-990 {
    margin: 0 auto;
  }
}
@media only screen and (min-width: 960px) {
  .max-width-over-960 {
    max-width: calc(100% - 350px) !important;
  }
  .show-under-959 {
    display: none;
  }
  .show-over-960 {
    display: block;
  }
  .spool-messages-max-width {
    max-width: calc(100vw - 550px) !important;
  }
}
@media only screen and (max-width: 959px) {
  .max-width-under-960 {
    width: 100% !important;
  }
  .padding-0-under-959 {
    padding: 0px !important;
  }
  .show-under-959 {
    display: block;
  }
  .show-over-960 {
    display: none;
  }
  .side-margin-auto-under-960 {
    margin: 0 auto;
  }
}
@media only screen and (max-width: 920px) {
  .hide-under-920 {
    display: none;
  }
  .max-width-under-920 {
    width: 100% !important;
  }
  .show-under-920 {
    display: block !important;
  }
}
@media only screen and (min-width: 920px) {
  .hide-over-920 {
    display: none;
  }
}
@media only screen and (min-width: 1100px) {
  .show-between-900-1100 {
    display: none;
  }
}
@media only screen and (max-width: 940px) {
  .hide-under-940 {
    display: none;
  }
}
@media only screen and (min-width: 901px) and (max-width: 1099px) {
  .show-between-900-1100 {
    display: block;
  }
}
@media only screen and (max-width: 900px) {
  .show-between-900-1100 {
    display: none;
  }
  .display-block-under-900 {
    display: block !important;
  }
  .width-100-under-900 {
    width: 100% !important;
  }
}
@media only screen and (min-width: 901px) {
  .show-under-900 {
    display: none;
  }
}
@media only screen and (min-width: 801px) and (max-width: 1099px) {
  .height-between-801-1099 {
    height: calc(100vh - 106px - var(--top-height)) !important;
  }
  .max-height-between-801-1099 {
    max-height: calc(100vh - 106px - var(--top-height)) !important;
  }
  .top-between-801-1099 {
    top: calc(101px + var(--top-height)) !important;
  }
  .width-between-801-1099 {
    width: calc(100% - 250px) !important;
  }
}
@media only screen and (min-width: 801px) and (max-width: 1100px) {
  .inbox-spool-container {
    max-width: calc(100% - 330px);
  }
  .hide-inbox-container {
    max-width: 100% !important;
  }
}
@media only screen and (min-width: 801px) {
  .margin-top-over-801 {
    margin-top: 1px;
  }
  .messages-max-width {
    max-width: calc(100vw - 340px);
  }
  .show-over-801 {
    display: block;
  }
  .show-block-under-800 {
    display: none;
  }
  .show-flex-under-800 {
    display: none;
  }
  .show-under-800 {
    display: none !important;
  }
  .spool-list-height-over-801 {
    height: calc(var(--inner-height) - 89px);
  }
  .thread-height-over-801 {
    height: calc(var(--inner-height) - 170px) !important;
  }
  .thread-messaging-height-over-801 {
    height: calc(var(--inner-height) - 114px) !important;
  }
  .top-flush {
    top: calc(var(--top-height));
  }
}
@media only screen and (max-width: 800px) {
  .border-bottom-under-800 {
    border-bottom: 1px solid #f0f0f0;
  }
  .feed-topbar {
    display: block !important;
  }
  .hide-under-800 {
    display: none !important;
  }
  .hide-side-margins-under-800 {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .inbox-spool-container {
    max-width: 100%;
  }
  .flex-column-under-800 {
    flex-direction: column;
  }
  .font-18-under-800 {
    font-size: 18px !important;
  }
  .messages-max-width {
    max-width: 100vw;
  }
  .show-flex-over-801 {
    display: none;
  }
  .show-over-801 {
    display: none !important;
  }
  .margin-0-under-800 {
    margin-top: 0px !important;
  }
  .margin-left-0-under-800 {
    margin-left: 0px !important;
  }
  .margin-right-20-under-800 {
    margin-right: 20px !important;
  }
  .margin-top-under-800 {
    margin-top: 50px !important;
  }
  .max-width-under-800 {
    max-width: 100% !important;
  }
  .padding-bottom-under-800 {
    padding-bottom: 15px !important;
  }
  .padding-under-800 {
    padding: 0 20px !important;
  }
  .show-block-under-800 {
    display: block !important;
  }
  .show-flex-under-800 {
    display: flex !important;
  }
  .show-under-800 {
    display: block;
  }
  .top-flush {
    top: var(--top-height);
  }
  .top-50-under-800 {
    top: 50px !important;
  }
  .width-100-under-800 {
    width: 100% !important;
  }
}
@media only screen and (min-width: 601px) and (max-width: 800px) {
  .thread-height-601-to-800 {
    height: calc(var(--inner-height) - 150px - var(--top-height)) !important;
  }
  .thread-messaging-height-601-to-800 {
    height: calc(var(--inner-height) - 154px) !important;
  }
}
@media only screen and (max-width: 719px) {
  .padding-top-40-under-720 {
    padding-top: 40px;
  }
}
@media only screen and (min-width: 700px) {
  .show-under-699 {
    display: none !important;
  }
}
@media only screen and (max-width: 700px) {
  .display-block-under-700 {
    display: block !important;
  }
  .hide-under-700 {
    display: none !important;
  }
  .text-align-center-under-700 {
    text-align: center;
  }
}
@media only screen and (max-width: 699px) {
  .show-over-700 {
    display: none !important;
  }
  .max-width-under-699 {
    width: 100% !important;
  }
}
@media only screen and (max-width: 675px) {
  .width-over-675px {
    display: none;
  }
}
@media only screen and (min-width: 601px) {
  .fixed-position-over-601 {
    position: fixed;
    left: 0;
    right: 0;
  }
  .search-results {
    left: 0;
    right: 0;
    top: 61px;
    max-height: 2500px;
    overflow-y: scroll;
    position: absolute;
  }
  .show-over-601 {
    display: block;
  }
  .show-under-600 {
    display: none !important;
  }
  .spool-messages-max-width {
    max-width: calc(100vw - 250px);
  }
}
@media only screen and (max-width: 600px) {
  .action-complete {
    left: 15px !important;
    top: calc(100vh - 80px) !important;
  }
  .border-radius-0-under-600 {
    border-radius: 0px !important;
  }
  .center-style {
    margin: 10px auto !important;
  }
  .default-overflow-under-600 {
    overflow: visible !important;
  }
  .digest-imgbox {
    margin: auto !important;
  }
  .digest-vote {
    text-align: center !important;
    padding-right: 30px;
  }
  .digest-content {
    margin-top: 80px;
    margin-left: -30px;
    min-height: 0px !important;
  }
  .digest-markdown {
    min-height: 0px !important;
  }
  .display-block-under-600 {
    display: block !important;
  }
  .feed-content {
    margin-right: 0px !important;
    margin-top: -50px !important;
    padding-top: 60px !important;
    height: 100vh !important;
  }
  .flex-wrap-under-600 {
    flex-wrap: wrap;
  }
  .font-size-24-under-600 {
    font-size: 24px !important;
  }
  .font-size-34-under-600 {
    font-size: 34px !important;
  }
  .font-size-42-under-600 {
    font-size: 42px !important;
  }
  .full-height-under-600 {
    height: 100% !important;
    max-height: 100% !important;
  }
  .full-width-under-600 {
    width: 100% !important;
  }
  .full-width-minus-35-under-600 {
    width: calc(100% - 35px) !important;
  }
  .height-under-600 {
    height: 100vh !important;
  }
  .hide-under-600 {
    display: none !important;
  }
  .inner-height-under-600 {
    height: var(--inner-height) !important;
  }
  .left-margin-under-600 {
    margin-left: 20px !important;
  }
  .margin-auto-under-600 {
    margin: 20px auto 0 !important;
  }
  .margin-left-0-under-600 {
    margin-left: 0px !important;
  }
  .margin-right-auto-under-600 {
    margin-right: auto !important;
  }
  .margin-right-10-under-600 {
    margin-right: 10px !important;
  }
  .margin-top-under-600 {
    margin-top: 20px !important;
  }
  .margin-under-600 {
    margin-bottom: 83px !important;
  }
  .max-width-80-under-600 {
    max-width: 80%;
  }
  .messages {
    height: calc(100vh - 210px) !important;
  }
  .messages-messaging {
    height: calc(100vh - 324px) !important;
  }
  .no-margin-under-600 {
    margin: 0px !important;
  }
  .no-margin-right-under-600 {
    margin-right: 0px !important;
  }
  .no-padding-under-600 {
    padding: 0px !important;
  }
  .padding-left-20-under-600 {
    padding-left: 20px !important;
  }
  .padding-under-600 {
    padding: 0 20px !important;
  }
  .padding-20px-under-600 {
    padding: 20px !important;
  }
  .show-block-under-600 {
    display: block !important;
  }
  .search-results {
    margin-top: -20px;
    margin-bottom: 20px;
  }
  .show-over-601 {
    display: none !important;
  }
  .show-under-600 {
    display: block;
  }
  .side-margins-0-under-600 {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .side-margins-20-under-600 {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
  .side-margins-25-under-600 {
    margin-left: 25px !important;
    margin-right: 25px !important;
  }
  .side-padding-0-under-600 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .side-padding-10-under-600 {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .side-padding-15-under-600 {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .side-padding-20-under-600 {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .side-padding-25-under-600 {
    padding-left: 25px !important;
    padding-right: 25px !important;
  }
  .spool-messages-max-width {
    max-width: 100vw;
  }
  .text-align-center-under-600 {
    text-align: center;
  }
  .thread-height-under-600 {
    height: calc(var(--inner-height) - 149px - var(--top-height));
  }
  .top-under-600 {
    top: 34px !important;
  }
  .width-70-under-600 {
    width: 70% !important;
  }
  .width-100-under-600 {
    width: 100% !important;
  }
  .zero-top-under-600 {
    top: 0px !important;
  }
}
@media only screen and (max-width: 555px) {
  .no-margin-under-555 {
    margin-right: 0 !important;
  }
}
@media only screen and (max-width: 569px) {
  .height-50-under-569 {
    height: 50px !important;
  }
}
@media only screen and (max-width: 450px) {
  .padding-20-under-450 {
    padding: 20px !important;
  }
}
@media only screen and (min-width: 401px) {
  .show-flex-over-401 {
    display: flex;
  }
  .show-flex-under-400 {
    display: none !important;
  }
  .show-under-400 {
    display: none !important;
  }
}
@media only screen and (max-width: 400px) {
  .border-radius-5-under-400 {
    border-radius: 5px !important;
  }
  .carbon-background-under-400 {
    background-color: #2a2a2a !important;
  }
  .display-block-under-400 {
    display: block !important;
  }
  .font-size-32-under-400 {
    font-size: 32px !important;
  }
  .font-size-30px-under-400 {
    font-size: 30px !important;
  }
  .font-size-16px-under-400 {
    font-size: 16px !important;
  }
  .full-width-under-400 {
    width: 100% !important;
  }
  .hide-under-400 {
    display: none !important;
  }
  .justify-content-center-under-400 {
    justify-content: center;
  }
  .margin-0-under-400 {
    margin: 0px !important;
  }
  .no-flex-under-400 {
    display: block !important;
  }
  .reaction-text {
    display: none;
  }
  .show-flex-over-401 {
    display: none !important;
  }
  .show-flex-under-400 {
    display: flex;
  }
  .side-padding-20-under-400 {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .text-align-center-under-400 {
    text-align: center;
  }
}
@media only screen and (max-width: 369px) {
  .hide-under-369 {
    display: none !important;
  }
  .width-under-369 {
    width: calc(100% - 50px) !important;
  }
}
@media only screen and (max-width: 350px) {
  .no-flex-under-350 {
    display: block !important;
  }
  .margin-bottom-under-350 {
    margin-bottom: 15px;
  }
  .text-align-under-350 {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/fonts.less","webpack://./src/components/styles/global.less","webpack://./src/components/styles/styles.less"],"names":[],"mappings":"AACA;EACE,2BAAA;EACA,+DAAA;ACAF;ADGA;EACE,mCAAA;EACA,+DAAA;ACDF;ADIA;EACE,0BAAA;EACA,+DAAA;ACFF;ADKA;EACE,kCAAA;EACA,+DAAA;ACHF;ADMA;EACE,2BAAA;EACA,+DAAA;ACJF;ADOA;EACE,mCAAA;EACA,+DAAA;ACLF;ADQA;EACE,2BAAA;EACA,+DAAA;ACNF;ADSA;EACE,mCAAA;EACA,+DAAA;ACPF;ADUA;EACE,4BAAA;EACA,+DAAA;ACRF;ADWA;EACE,oCAAA;EACA,+DAAA;ACTF;ADYA;EACE,6BAAA;EACA,gEAAA;ACVF;ADaA;EACE,2BAAA;EACA,gEAAA;ACXF;ADcA;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;ACZF;ADcE;EACE,eAAA;EACA,iBAAA;ACZJ;ADgBA;EACE,sCAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;ACdF;ADiBA;EACE,sCAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;ACfF;ADkBA;EACE,qCAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;AChBF;ADkBE;EACE,eAAA;AChBJ;ADoBA;EACE,oCAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AClBF;ADoBE;EACE,eAAA;AClBJ;ADsBA;EACE,oCAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;ACpBF;ADuBA;EACE,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;ACrBF;ADwBA;EACE,oCAAA;EACA,eAAA;EACA,oBAAA;ACtBF;ADyBA;EACE,oCAAA;EACA,eAAA;EACA,oBAAA;ACvBF;AD0BA;EACE,oCAAA;EACA,eAAA;EACA,kBAAA;ACxBF;AD2BA;EACE,qCAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;ACzBF;AD2BE;EACE,eAAA;ACzBJ;AD6BA;EACE,4CAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AC3BF;AD8BA;EACE,sCAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AC5BF;AD8BE;EACE,eAAA;AC5BJ;AACA,iBAAiB;ACzIjB;EACE,UAAA;EACA,SAAA;AD2IF;AACA,oBAAoB;ACxIpB;EACE;IACE,wBAAA;ED0IF;AACF;ACvIA;EACE;IACE,wBAAA;EDyIF;ECtIA;IACE,sDAAA;EDwIF;AACF;ACrIA;EACE;IACE,gCAAA;EDuIF;ECpIA;;;;IAIE,yBAAA;EDsIF;ECnIA;;;IAGE,wBAAA;EDqIF;EClIA;IACE,yBAAA;IACA,0BAAA;EDoIF;ECjIA;;;;IAIE,0BAAA;EDmIF;EChIA;IACE,sBAAA;EDkIF;EC/HA;IACE,0BAAA;EDiIF;EC9HA;;;;IAIE,oBAAA;IACA,oBAAA;EDgIF;EC7HA;IACE,6BAAA;ED+HF;EC5HA;;IAEE,6BAAA;ED8HF;EC3HA;IACE,sBAAA;ED6HF;AACF;AACA,qBAAqB;AC1HrB;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AD4HF;ACzHA;EACE,cAAA;AD2HF;ACxHA;EACE,cAAA;AD0HF;ACvHA;EACE,mCAAA;ADyHF;ACtHA;EACE,cAAA;ADwHF;ACrHA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;ADuHF;ACpHA;EACE,sBAAA;ADsHF;ACnHA;EACE,6BAAA;EACA,kBAAA;ADqHF;ACnHE;EACE,oCAAA;EACA,qCAAA;EACA,mBAAA;EACA,gDAAA;EAGA,UAAA;ADmHJ;AC/GA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;ADiHF;AC9GA;;;;;EAKE,aAAA;ADgHF;AC7GA;EACE,yBAAA;AD+GF;AC5GA;EACE,YAAA;AD8GF;AC3GA;EACE,mBAAA;AD6GF;AC1GA;EACE,uBAAA;AD4GF;ACzGA;EACE,mBAAA;EACA,uBAAA;AD2GF;ACxGA;EACE,uDAAA;AD0GF;ACvGA;EACE,eAAA;EACA,kCAAA;ADyGF;ACvGE;EACE,8BAAA;ADyGJ;ACrGA;EACE,eAAA;EACA,6CAAA;ADuGF;ACrGE;EACE,iDAAA;ADuGJ;ACnGA;EACE,eAAA;EACA,6CAAA;ADqGF;ACnGE;EACE,6CAAA;ADqGJ;ACjGA;EACE,eAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;ADmGF;AChGA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;ADkGF;AC/FA;EACE,6CAAA;ADiGF;AC/FE;EACE,oCAAA;ADiGJ;AC7FA;EACI,yCAAA;AD+FJ;AC7FI;EACI,oCAAA;EACA,iCAAA;AD+FR;AC5FA;EACI,kBAAA;AD8FJ;AC5FI;ED8FF,8FAA8F;AAChG;AC7FQ;EACI,wCAAA;EACA,iCAAA;EACA,sCAAA;ED+FV,gEAAgE;AAClE;AC7FY;EACI,aAAA;AD+FhB;AC3GA;EAkBQ,aAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,QAAA;AD4FR;ACxFA;EACI,oCAAA;EACA,iCAAA;AD0FJ;ACxFG;EACK,wBAAA;AD0FR;ACtFA;EACE,sJAAA;EACA,sBAAA;ADwFF;ACrFA;EACE,sJAAA;EACA,sBAAA;ADuFF;ACpFA;EACE,wBAAA;ADsFF;ACnFA;EACE,wBAAA;ADqFF;AClFA;EACE,6JAAA;EACA,sBAAA;ADoFF;ACjFA;EACE,uJAAA;EACA,sBAAA;ADmFF;AChFA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;ADkFF;AC/EA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;ADiFF;AC9EA;EACE,gBAAA;EACA,iCAAA;ADgFF;AC7EA;EACE,eAAA;AD+EF;AC5EA;EACE,2BAAA;EACA,uBAAA;AD8EF;AChFA;EAKI,yBAAA;AD8EJ;AC1EA;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AD4EF;AC1EE;EACE,kBAAA;AD4EJ;ACzEE;EACE,2CAAA;AD2EJ;ACxEE;EACE,2CAAA;AD0EJ;ACtEA;EACE,gBAAA;EACA,wBAAA;ADwEF;ACrEA;EACE,kBAAA;ADuEF;ACpEA;EACE,yBAAA;ADsEF;ACnEA;EACE,eAAA;EACA,aAAA;ADqEF;ACjEA;EACE,cAAA;ADmEF;AChEA;EACE,0BAAA;ADkEF;AAvbA;EACE,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,qBAAA;EACA,wBAAA;AAybF;AAtbA;EAhBE,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,qBAAA;EACA,wBAAA;AAycF;AAlcA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,wCAAA;EACA,oBAAA;AAocF;AAjcA;;;;;;;;;;;;EAYE,cAAA;AAmcF;AAhcA;;EAEE,YAAA;AAkcF;AA/bA;;EAEE,6BAAA;AAicF;AA9bA;EACE,kBAAA;AAgcF;AA7bA;EACE,wBAAA;AA+bF;AA5bA;EACE,kBAAA;AA8bF;AA1bE;EACE,0BAAA;AA4bJ;AAxbA;;EAEE,wBAAA;EACA,SAAA;AA0bF;AAvbA;;EAEE,2BAAA;AAybF;AAtbA;EACE,cAAA;EACA,UAAA;AAwbF;AArbA;EACE,sBAAA;EACA,kBAAA;EACA,+CAAA;AAubF;AArbE;EACE,yBAAA;EACA,kBAAA;AAubJ;AAnbI;EACE,yBAAA;EACA,kBAAA;AAqbN;AAlbI;EACE,yBAAA;EACA,kBAAA;AAobN;AA/aI;EACE,yBAAA;EACA,kBAAA;AAibN;AA9aI;EACE,yBAAA;EACA,kBAAA;AAgbN;AA3aI;;EAEE,kBAAA;EACA,QAAA;EACA,UAAA;AA6aN;AAxaA;EACE,yBAAA;EACA,iBAAA;AA0aF;AAvaA;EACE,0BAAA;AAyaF;AACA,wBAAwB;AAraxB;EACE;IACE,wBAAA;EAuaF;AACF;AApaA;EACE;IACE,aAAA;EAsaF;AACF;AAnaA;EACE;IACE,wBAAA;EAqaF;AACF;AAlaA;EACE;IACE,aAAA;EAoaF;EAjaA;IACE,gDAAA;EAmaF;EAhaA;IACE,4CAAA;EAkaF;AACF;AA/ZA;EACE;IACE,aAAA;EAiaF;EA9ZA;IACE,0BAAA;IACA,2BAAA;EAgaF;AACF;AA7ZA;EACE;IACE,mBAAA;EA+ZF;EA5ZA;IACE,wBAAA;EA8ZF;AACF;AA3ZA;EACE;IACE,aAAA;EA6ZF;EA1ZA;IACE,mBAAA;EA4ZF;AACF;AAzZA;EACE;IACE,cAAA;EA2ZF;EAxZA;IACE,2BAAA;EA0ZF;AACF;AAvZA;EACE;IACE,aAAA;EAyZF;AACF;AAtZA;EACE;IACE,yCAAA;EAwZF;EArZA;IACE,cAAA;EAuZF;AACF;AApZA;EACE;IACE,aAAA;EAsZF;AACF;AAnZA;EACE;IACE,aAAA;EAqZF;EAlZA;IACE,aAAA;EAoZF;EAjZA;IACE,aAAA;EAmZF;AACF;AAhZA;EACE;IACE,wBAAA;EAkZF;EA/YA;IACE,wCAAA;EAiZF;EA9YA;IACE,wCAAA;EAgZF;AACF;AA7YA;EACE;IACE,uBAAA;EA+YF;EA5YA;IACE,cAAA;EA8YF;EA3YA;IACE,yBAAA;EA6YF;EA1YA;IACE,wBAAA;EA4YF;EAzYA;IACE,YAAA;EA2YF;EAxYA;IACE,eAAA;EA0YF;AACF;AAvYA;EACE;IACE,uBAAA;EAyYF;AACF;AAtYA;EACE;IACE,wBAAA;EAwYF;EArYA;IACE,sDAAA;EAuYF;AACF;AApYA;EACE;IACE,wBAAA;EAsYF;EAnYA;IACE,yBAAA;EAqYF;EAlYA;IACE,wBAAA;EAoYF;AACF;AAjYA;EACE;IACE,aAAA;EAmYF;EAhYA;IACE,aAAA;EAkYF;AACF;AA/XA;EACE;IACE,aAAA;EAiYF;EA9XA;IACE,aAAA;EAgYF;AACF;AA7XA;EACE;IACE,aAAA;EA+XF;EA5XA;IACE,cAAA;EA8XF;EA3XA;IACE,YAAA;IACA,gBAAA;EA6XF;AACF;AA1XA;EACE;IACE,aAAA;EA4XF;EAzXA;IACE,cAAA;EA2XF;EAxXA;IACE,cAAA;EA0XF;AACF;AAvXA;EACE;IACE,wCAAA;EAyXF;EAtXA;IACE,aAAA;EAwXF;EArXA;IACE,cAAA;EAuXF;EApXA;IACE,yCAAA;EAsXF;AACF;AAnXA;EACE;IACE,sBAAA;EAqXF;EAlXA;IACE,uBAAA;EAoXF;EAjXA;IACE,cAAA;EAmXF;EAhXA;IACE,aAAA;EAkXF;EA/WA;IACE,cAAA;EAiXF;AACF;AA9WA;EACE;IACE,aAAA;EAgXF;EA7WA;IACE,sBAAA;EA+WF;EA5WA;IACE,yBAAA;EA8WF;AACF;AA3WA;EACE;IACE,aAAA;EA6WF;AACF;AA1WA;EACE;IACE,aAAA;EA4WF;AACF;AAzWA;EACE;IACE,aAAA;EA2WF;AACF;AAxWA;EACE;IACE,cAAA;EA0WF;AACF;AAvWA;EACE;IACE,aAAA;EAyWF;EAtWA;IACE,yBAAA;EAwWF;EArWA;IACE,sBAAA;EAuWF;AACF;AApWA;EACE;IACE,aAAA;EAsWF;AACF;AAnWA;EACE;IACE,0DAAA;EAqWF;EAlWA;IACE,8DAAA;EAoWF;EAjWA;IACE,+CAAA;EAmWF;EAhWA;IACE,oCAAA;EAkWF;AACF;AA/VA;EACE;IACE,6BAAA;EAiWF;EA9VA;IACE,0BAAA;EAgWF;AACF;AA7VA;EACE;IACE,eAAA;EA+VF;EA5VA;IACE,8BAAA;EA8VF;EA3VA;IACE,cAAA;EA6VF;EA1VA;IACE,aAAA;EA4VF;EAzVA;IACE,aAAA;EA2VF;EAxVA;IACE,wBAAA;EA0VF;EAvVA;IACE,wCAAA;EAyVF;EAtVA;IACE,oDAAA;EAwVF;EArVA;IACE,oDAAA;EAuVF;EApVA;IACE,4BAAA;EAsVF;AACF;AAnVA;EACE;IACE,gCAAA;EAqVF;EAlVA;IACE,yBAAA;EAoVF;EAjVA;IACE,wBAAA;EAmVF;EAhVA;IACE,2BAAA;IACA,4BAAA;EAkVF;EA/UA;IACE,eAAA;EAiVF;EA9UA;IACE,sBAAA;EAgVF;EA7UA;IACE,0BAAA;EA+UF;EA5UA;IACE,gBAAA;EA8UF;EA3UA;IACE,aAAA;EA6UF;EA1UA;IACE,wBAAA;EA4UF;EAzUA;IACE,0BAAA;EA2UF;EAxUA;IACE,2BAAA;EA0UF;EAvUA;IACE,6BAAA;EAyUF;EAtUA;IACE,2BAAA;EAwUF;EArUA;IACE,0BAAA;EAuUF;EApUA;IACE,+BAAA;EAsUF;EAnUA;IACE,0BAAA;EAqUF;EAlUA;IACE,yBAAA;EAoUF;EAjUA;IACE,wBAAA;EAmUF;EAhUA;IACE,cAAA;EAkUF;EA/TA;IACE,sBAAA;EAiUF;EA9TA;IACE,oBAAA;EAgUF;EA7TA;IACE,sBAAA;EA+TF;AACF;AA5TA;EACE;IACE,wEAAA;EA8TF;EA3TA;IACE,oDAAA;EA6TF;AACF;AA1TA;EACE;IACE,iBAAA;EA4TF;AACF;AAzTA;EACE;IACE,wBAAA;EA2TF;AACF;AAxTA;EACE;IACE,yBAAA;EA0TF;EAvTA;IACE,wBAAA;EAyTF;EAtTA;IACE,kBAAA;EAwTF;AACF;AArTA;EACE;IACE,wBAAA;EAuTF;EApTA;IACE,sBAAA;EAsTF;AACF;AAnTA;EACE;IACE,aAAA;EAqTF;AACF;AAlTA;EACE;IACE,eAAA;IACA,OAAA;IACA,QAAA;EAoTF;EAjTA;IACE,OAAA;IACA,QAAA;IACA,SAAA;IACA,kBAAA;IACA,kBAAA;IACA,kBAAA;EAmTF;EAhTA;IACE,cAAA;EAkTF;EA/SA;IACE,wBAAA;EAiTF;EA9SA;IACE,8BAAA;EAgTF;AACF;AA7SA;EACE;IACE,qBAAA;IACA,kCAAA;EA+SF;EA5SA;IACE,6BAAA;EA8SF;EA3SA;IACE,4BAAA;EA6SF;EA1SA;IACE,4BAAA;EA4SF;EAzSA;IACE,uBAAA;EA2SF;EAxSA;IACE,6BAAA;IACA,mBAAA;EA0SF;EAvSA;IACE,gBAAA;IACA,kBAAA;IACA,0BAAA;EAySF;EAtSA;IACE,0BAAA;EAwSF;EArSA;IACE,yBAAA;EAuSF;EApSA;IACE,4BAAA;IACA,4BAAA;IACA,4BAAA;IACA,wBAAA;EAsSF;EAnSA;IACE,eAAA;EAqSF;EAlSA;IACE,0BAAA;EAoSF;EAjSA;IACE,0BAAA;EAmSF;EAhSA;IACE,0BAAA;EAkSF;EA/RA;IACE,uBAAA;IACA,2BAAA;EAiSF;EA9RA;IACE,sBAAA;EAgSF;EA7RA;IACE,mCAAA;EA+RF;EA5RA;IACE,wBAAA;EA8RF;EA3RA;IACE,wBAAA;EA6RF;EA1RA;IACE,sCAAA;EA4RF;EAzRA;IACE,4BAAA;EA2RF;EAxRA;IACE,8BAAA;EA0RF;EAvRA;IACE,2BAAA;EAyRF;EAtRA;IACE,6BAAA;EAwRF;EArRA;IACE,6BAAA;EAuRF;EApRA;IACE,2BAAA;EAsRF;EAnRA;IACE,8BAAA;EAqRF;EAlRA;IACE,cAAA;EAoRF;EAjRA;IACE,sCAAA;EAmRF;EAhRA;IACE,sCAAA;EAkRF;EA/QA;IACE,sBAAA;EAiRF;EA9QA;IACE,4BAAA;EAgRF;EA7QA;IACE,uBAAA;EA+QF;EA5QA;IACE,6BAAA;EA8QF;EA3QA;IACE,0BAAA;EA6QF;EA1QA;IACE,wBAAA;EA4QF;EAzQA;IACE,yBAAA;EA2QF;EAxQA;IACE,iBAAA;IACA,mBAAA;EA0QF;EAvQA;IACE,wBAAA;EAyQF;EAtQA;IACE,cAAA;EAwQF;EArQA;IACE,2BAAA;IACA,4BAAA;EAuQF;EApQA;IACE,4BAAA;IACA,6BAAA;EAsQF;EAnQA;IACE,4BAAA;IACA,6BAAA;EAqQF;EAlQA;IACE,4BAAA;IACA,6BAAA;EAoQF;EAjQA;IACE,6BAAA;IACA,8BAAA;EAmQF;EAhQA;IACE,6BAAA;IACA,8BAAA;EAkQF;EA/PA;IACE,6BAAA;IACA,8BAAA;EAiQF;EA9PA;IACE,6BAAA;IACA,8BAAA;EAgQF;EA7PA;IACE,gBAAA;EA+PF;EA5PA;IACE,kBAAA;EA8PF;EA3PA;IACE,6DAAA;EA6PF;EA1PA;IACE,oBAAA;EA4PF;EAzPA;IACE,qBAAA;EA2PF;EAxPA;IACE,sBAAA;EA0PF;EAvPA;IACE,mBAAA;EAyPF;AACF;AAtPA;EACE;IACE,0BAAA;EAwPF;AACF;AArPA;EACE;IACE,uBAAA;EAuPF;AACF;AApPA;EACE;IACE,wBAAA;EAsPF;AACF;AAnPA;EACE;IACE,aAAA;EAqPF;EAlPA;IACE,wBAAA;EAoPF;EAjPA;IACE,wBAAA;EAmPF;AACF;AAhPA;EACE;IACE,6BAAA;EAkPF;EA/OA;IACE,oCAAA;EAiPF;EA9OA;IACE,yBAAA;EAgPF;EA7OA;IACE,0BAAA;EA+OF;EA5OA;IACE,0BAAA;EA8OF;EA3OA;IACE,0BAAA;EA6OF;EA1OA;IACE,sBAAA;EA4OF;EAzOA;IACE,wBAAA;EA2OF;EAxOA;IACE,uBAAA;EA0OF;EAvOA;IACE,sBAAA;EAyOF;EAtOA;IACE,yBAAA;EAwOF;EArOA;IACE,aAAA;EAuOF;EApOA;IACE,wBAAA;EAsOF;EAnOA;IACE,aAAA;EAqOF;EAlOA;IACE,6BAAA;IACA,8BAAA;EAoOF;EAjOA;IACE,kBAAA;EAmOF;AACF;AAhOA;EACE;IACE,wBAAA;EAkOF;EA/NA;IACE,mCAAA;EAiOF;AACF;AA9NA;EACE;IACE,yBAAA;EAgOF;EA7NA;IACE,mBAAA;EA+NF;EA5NA;IACE,kBAAA;EA8NF;AACF","sourcesContent":["// src/assets/styles/fonts.less\n@font-face {\n  font-family: 'avenir-black';\n  src: url('../../../public/assets/fonts/avenir-black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-black-oblique';\n  src: url('../../../public/assets/fonts/avenir-black-oblique.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-book';\n  src: url('../../../public/assets/fonts/avenir-book.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-book-oblique';\n  src: url('../../../public/assets/fonts/avenir-book-oblique.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-heavy';\n  src: url('../../../public/assets/fonts/avenir-heavy.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-heavy-oblique';\n  src: url('../../../public/assets/fonts/avenir-heavy-oblique.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-light';\n  src: url('../../../public/assets/fonts/avenir-light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-light-oblique';\n  src: url('../../../public/assets/fonts/avenir-light-oblique.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-medium';\n  src: url('../../../public/assets/fonts/avenir-medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-medium-oblique';\n  src: url('../../../public/assets/fonts/avenir-medium-oblique.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-oblique';\n  src: url('../../../public/assets/fonts/avenir-oblique.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'avenir-roman';\n  src: url('../../../public/assets/fonts/avenir-roman.ttf') format('truetype');\n}\n\nh1 {\n  font-family: avenir-book, sans-serif;\n  font-size: 28px;\n  line-height: 125%;\n\n  &.h1-small {\n    font-size: 24px;\n    letter-spacing: 0;\n  }\n}\n\nh2 {\n  font-family: avenir-medium, sans-serif;\n  font-size: 20px;\n  letter-spacing: 0.2px;\n  line-height: 150%;\n}\n\nh3 {\n  font-family: avenir-medium, sans-serif;\n  font-size: 18px;\n  letter-spacing: 0.2px;\n  line-height: 150%;\n}\n\nh4 {\n  font-family: avenir-heavy, sans-serif;\n  font-size: 16px;\n  letter-spacing: 0.4%;\n  line-height: 24px;\n\n  &.h4-small {\n    font-size: 14px;\n  }\n}\n\nbody {\n  font-family: avenir-book, sans-serif;\n  font-size: 16px;\n  letter-spacing: 0.25px;\n  line-height: 24px;\n\n  &.-small {\n    font-size: 14px;\n  }\n}\n\n.body-small {\n  font-family: avenir-book, sans-serif;\n  font-size: 14px;\n  letter-spacing: 0.25px;\n  line-height: 24px;\n}\n\n.button-label {\n  font-family: avenir, sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 24px;\n}\n\n.label-large {\n  font-family: avenir-book, sans-serif;\n  font-size: 14px;\n  letter-spacing: 0.1%;\n}\n\n.label-medium {\n  font-family: avenir-book, sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.4%;\n}\n\n.label-small {\n  font-family: avenir-book, sans-serif;\n  font-size: 10px;\n  letter-spacing: 1%;\n}\n\n.link {\n  font-family: avenir-heavy, sans-serif;\n  font-size: 16px;\n  letter-spacing: 0.25px;\n  line-height: 24px;\n  color: var(--blue);\n\n  &.small {\n    font-size: 14px;\n  }\n}\n\n.monospace {\n  font-family: 'Major Mono Display', monospace;\n  font-size: 12px;\n  line-height: 21px;\n  letter-spacing: 0.25px;\n}\n\n.subheadline {\n  font-family: avenir-medium, sans-serif;\n  font-size: 24px;\n  letter-spacing: 0.2px;\n  line-height: 150%;\n\n  &.small {\n    font-size: 20px;\n  }\n}\n","// styles.less\n\n@import 'fonts.less';\n@import 'variables.less';\n@import 'styles.less';\n\n.reset {\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background: none;\n  border: 0;\n  box-sizing: border-box;\n  color: inherit;\n  font: inherit;\n  font-size: 100%;\n  margin: 0;\n  outline: none;\n  padding: 0;\n  text-decoration: none;\n  vertical-align: baseline;\n}\n\n* {\n  .reset();\n}\n\n:root {\n  --inner-height: 100vh;\n  --blue: @blue;\n  --paleblue: @paleblue;\n  --black: @black;\n  --black02: @black02;\n  --green: @green;\n  --green02: @green02;\n  --red: @red;\n  --orange: @orange;\n  --purple: @purple;\n  --pink: @pink;\n  --pink02: @pink02;\n  --teal: @teal;\n  --teal02: @teal02;\n  --highlightyellow: @highlightyellow;\n  --white: @white;\n  --lightoffwhite: @lightoffwhite;\n  --offwhite: @offwhite;\n  --mist: @mist;\n  --palepeach: @palepeach;\n  --carbon: @carbon;\n  --lightcarbon: @lightcarbon;\n  --titanium: @titanium;\n  --steel: @steel;\n  --grey: @grey;\n  --lightgrey: @lightgrey;\n  --backgroundgreen: @backgroundgreen;\n  --textgreen: @textgreen;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\ndel,\ns {\n  text-decoration: line-through;\n}\n\nem {\n  font-style: italic;\n}\n\ninput::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\ninput:focus::-webkit-input-placeholder {\n  color: transparent;\n}\n\ninput[type='number'] {\n  &.form-disable-spinner {\n    -moz-appearance: textfield;\n  }\n}\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\nol,\nul {\n  list-style-position: inside;\n}\n\n::placeholder {\n  color: #bbbbbb;\n  opacity: 1;\n}\n\nprogress {\n  background-color: #eee;\n  border-radius: 5px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25) inset;\n\n  &::-webkit-progress-bar {\n    background-color: #e0e0e0;\n    border-radius: 4px;\n  }\n\n  &.progress-blue {\n    &::-webkit-progress-value {\n      background-color: @blue;\n      border-radius: 4px;\n    }\n\n    &::-moz-progress-bar {\n      background-color: @blue;\n      border-radius: 4px;\n    }\n  }\n\n  &.progress-green {\n    &::-webkit-progress-value {\n      background-color: @green;\n      border-radius: 4px;\n    }\n\n    &::-moz-progress-bar {\n      background-color: @green;\n      border-radius: 4px;\n    }\n  }\n\n  &[value] {\n    &::-webkit-progress-value::before,\n    &::-moz-progress-value::before {\n      position: absolute;\n      right: 0;\n      top: -125%;\n    }\n  }\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nu {\n  text-decoration: underline;\n}\n\n/** RESPONSIVE DESIGN **/\n\n@media only screen and (min-width: 1280px) {\n  .hide-over-1280 {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 1201px) {\n  .show-under-1200 {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 1024px) {\n  .hide-over-1024 {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 801px) {\n  .hide-over-801 {\n    display: none;\n  }\n\n  .full-max-height-over-801 {\n    max-height: calc(var(--inner-height)) !important;\n  }\n\n  .full-height-over-801 {\n    height: calc(var(--inner-height)) !important;\n  }\n}\n\n@media only screen and (min-width: 800px) {\n  .hide-over-800 {\n    display: none;\n  }\n\n  .font-over-800 {\n    font-size: 48px !important;\n    margin-left: 22% !important;\n  }\n}\n\n@media only screen and (min-width: 400px) {\n  .nowrap-over-400 {\n    white-space: nowrap;\n  }\n\n  .hide-over-400 {\n    display: none !important;\n  }\n}\n\n@media only screen and (max-width: 1440px) {\n  .show-over-1440 {\n    display: none;\n  }\n\n  .landing-card {\n    border-radius: 10px;\n  }\n}\n\n@media only screen and (min-width: 1367px) {\n  .show-over-1367 {\n    display: block;\n  }\n\n  .max-width-660-over-1367 {\n    max-width: 660px !important;\n  }\n}\n\n@media only screen and (max-width: 1366px) {\n  .show-over-1367 {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 1280px) {\n  .messages-max-width {\n    max-width: calc(100vw - 640px) !important;\n  }\n\n  .show-over-1280 {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 1279px) {\n  .show-over-1280 {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 1200px) {\n  .feed-right-sidebar {\n    display: none;\n  }\n\n  .hide-under-1200 {\n    display: none;\n  }\n\n  .feed-left-sidebar {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 1100px) {\n  .show-under-1099 {\n    display: none !important;\n  }\n\n  .max-width-minus-630-over-1100 {\n    max-width: calc(100% - 630px) !important;\n  }\n\n  .max-width-minus-385-over-1100 {\n    max-width: calc(100% - 385px) !important;\n  }\n}\n\n@media only screen and (max-width: 1099px) {\n  .full-height-under-1100 {\n    height: 100% !important;\n  }\n\n  .margin-under-1100 {\n    margin: 0 auto;\n  }\n\n  .no-flex-under-1100 {\n    display: block !important;\n  }\n\n  .show-over-1100 {\n    display: none !important;\n  }\n\n  .flex-grow-under-1099 {\n    flex-grow: 1;\n  }\n\n  .flex-wrap-under-1099 {\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 1099px) {\n  .width-under-1100 {\n    width: 550px !important;\n  }\n}\n\n@media only screen and (min-width: 601px) {\n  .hide-over-601 {\n    display: none !important;\n  }\n\n  .more-light-gray-background-on-hover:hover {\n    background-color: rgba(178, 178, 178, 0.15) !important;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .hide-under-1024 {\n    display: none !important;\n  }\n\n  .show-under-1024 {\n    display: block !important;\n  }\n\n  .show-flex-under-1024 {\n    display: flex !important;\n  }\n}\n\n@media only screen and (min-width: 1024px) {\n  .show-flex-under-1023 {\n    display: none;\n  }\n\n  .show-flex-over-1024 {\n    display: flex;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .show-flex-under-1023 {\n    display: flex;\n  }\n\n  .show-flex-over-1024 {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 990px) {\n  .show-under-989 {\n    display: none;\n  }\n\n  .show-over-990 {\n    display: block;\n  }\n\n  .width-over-990 {\n    width: 620px;\n    min-width: 620px;\n  }\n}\n\n@media only screen and (max-width: 989px) {\n  .show-over-990 {\n    display: none;\n  }\n\n  .show-under-989 {\n    display: block;\n  }\n\n  .side-margin-auto-under-990 {\n    margin: 0 auto;\n  }\n}\n\n@media only screen and (min-width: 960px) {\n  .max-width-over-960 {\n    max-width: calc(100% - 350px) !important;\n  }\n\n  .show-under-959 {\n    display: none;\n  }\n\n  .show-over-960 {\n    display: block;\n  }\n\n  .spool-messages-max-width {\n    max-width: calc(100vw - 550px) !important;\n  }\n}\n\n@media only screen and (max-width: 959px) {\n  .max-width-under-960 {\n    width: 100% !important;\n  }\n\n  .padding-0-under-959 {\n    padding: 0px !important;\n  }\n\n  .show-under-959 {\n    display: block;\n  }\n\n  .show-over-960 {\n    display: none;\n  }\n\n  .side-margin-auto-under-960 {\n    margin: 0 auto;\n  }\n}\n\n@media only screen and (max-width: 920px) {\n  .hide-under-920 {\n    display: none;\n  }\n\n  .max-width-under-920 {\n    width: 100% !important;\n  }\n\n  .show-under-920 {\n    display: block !important;\n  }\n}\n\n@media only screen and (min-width: 920px) {\n  .hide-over-920 {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 1100px) {\n  .show-between-900-1100 {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 940px) {\n  .hide-under-940 {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 901px) and (max-width: 1099px) {\n  .show-between-900-1100 {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 900px) {\n  .show-between-900-1100 {\n    display: none;\n  }\n\n  .display-block-under-900 {\n    display: block !important;\n  }\n\n  .width-100-under-900 {\n    width: 100% !important;\n  }\n}\n\n@media only screen and (min-width: 901px) {\n  .show-under-900 {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 801px) and (max-width: 1099px) {\n  .height-between-801-1099 {\n    height: calc(100vh - 106px - var(--top-height)) !important;\n  }\n\n  .max-height-between-801-1099 {\n    max-height: calc(100vh - 106px - var(--top-height)) !important;\n  }\n\n  .top-between-801-1099 {\n    top: calc(101px + var(--top-height)) !important;\n  }\n\n  .width-between-801-1099 {\n    width: calc(100% - 250px) !important;\n  }\n}\n\n@media only screen and (min-width: 801px) and (max-width: 1100px) {\n  .inbox-spool-container {\n    max-width: calc(100% - 330px);\n  }\n\n  .hide-inbox-container {\n    max-width: 100% !important;\n  }\n}\n\n@media only screen and (min-width: 801px) {\n  .margin-top-over-801 {\n    margin-top: 1px;\n  }\n\n  .messages-max-width {\n    max-width: calc(100vw - 340px);\n  }\n\n  .show-over-801 {\n    display: block;\n  }\n\n  .show-block-under-800 {\n    display: none;\n  }\n\n  .show-flex-under-800 {\n    display: none;\n  }\n\n  .show-under-800 {\n    display: none !important;\n  }\n\n  .spool-list-height-over-801 {\n    height: calc(var(--inner-height) - 89px);\n  }\n\n  .thread-height-over-801 {\n    height: calc(var(--inner-height) - 170px) !important;\n  }\n\n  .thread-messaging-height-over-801 {\n    height: calc(var(--inner-height) - 114px) !important;\n  }\n\n  .top-flush {\n    top: calc(var(--top-height));\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  .border-bottom-under-800 {\n    border-bottom: 1px solid #f0f0f0;\n  }\n\n  .feed-topbar {\n    display: block !important;\n  }\n\n  .hide-under-800 {\n    display: none !important;\n  }\n\n  .hide-side-margins-under-800 {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n  }\n\n  .inbox-spool-container {\n    max-width: 100%;\n  }\n\n  .flex-column-under-800 {\n    flex-direction: column;\n  }\n\n  .font-18-under-800 {\n    font-size: 18px !important;\n  }\n\n  .messages-max-width {\n    max-width: 100vw;\n  }\n\n  .show-flex-over-801 {\n    display: none;\n  }\n\n  .show-over-801 {\n    display: none !important;\n  }\n\n  .margin-0-under-800 {\n    margin-top: 0px !important;\n  }\n\n  .margin-left-0-under-800 {\n    margin-left: 0px !important;\n  }\n\n  .margin-right-20-under-800 {\n    margin-right: 20px !important;\n  }\n\n  .margin-top-under-800 {\n    margin-top: 50px !important;\n  }\n\n  .max-width-under-800 {\n    max-width: 100% !important;\n  }\n\n  .padding-bottom-under-800 {\n    padding-bottom: 15px !important;\n  }\n\n  .padding-under-800 {\n    padding: 0 20px !important;\n  }\n\n  .show-block-under-800 {\n    display: block !important;\n  }\n\n  .show-flex-under-800 {\n    display: flex !important;\n  }\n\n  .show-under-800 {\n    display: block;\n  }\n\n  .top-flush {\n    top: var(--top-height);\n  }\n\n  .top-50-under-800 {\n    top: 50px !important;\n  }\n\n  .width-100-under-800 {\n    width: 100% !important;\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 800px) {\n  .thread-height-601-to-800 {\n    height: calc(var(--inner-height) - 150px - var(--top-height)) !important;\n  }\n\n  .thread-messaging-height-601-to-800 {\n    height: calc(var(--inner-height) - 154px) !important;\n  }\n}\n\n@media only screen and (max-width: 719px) {\n  .padding-top-40-under-720 {\n    padding-top: 40px;\n  }\n}\n\n@media only screen and (min-width: 700px) {\n  .show-under-699 {\n    display: none !important;\n  }\n}\n\n@media only screen and (max-width: 700px) {\n  .display-block-under-700 {\n    display: block !important;\n  }\n\n  .hide-under-700 {\n    display: none !important;\n  }\n\n  .text-align-center-under-700 {\n    text-align: center;\n  }\n}\n\n@media only screen and (max-width: 699px) {\n  .show-over-700 {\n    display: none !important;\n  }\n\n  .max-width-under-699 {\n    width: 100% !important;\n  }\n}\n\n@media only screen and (max-width: 675px) {\n  .width-over-675px {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 601px) {\n  .fixed-position-over-601 {\n    position: fixed;\n    left: 0;\n    right: 0;\n  }\n\n  .search-results {\n    left: 0;\n    right: 0;\n    top: 61px;\n    max-height: 2500px;\n    overflow-y: scroll;\n    position: absolute;\n  }\n\n  .show-over-601 {\n    display: block;\n  }\n\n  .show-under-600 {\n    display: none !important;\n  }\n\n  .spool-messages-max-width {\n    max-width: calc(100vw - 250px);\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .action-complete {\n    left: 15px !important;\n    top: calc(100vh - 80px) !important;\n  }\n\n  .border-radius-0-under-600 {\n    border-radius: 0px !important;\n  }\n\n  .center-style {\n    margin: 10px auto !important;\n  }\n\n  .default-overflow-under-600 {\n    overflow: visible !important;\n  }\n\n  .digest-imgbox {\n    margin: auto !important;\n  }\n\n  .digest-vote {\n    text-align: center !important;\n    padding-right: 30px;\n  }\n\n  .digest-content {\n    margin-top: 80px;\n    margin-left: -30px;\n    min-height: 0px !important;\n  }\n\n  .digest-markdown {\n    min-height: 0px !important;\n  }\n\n  .display-block-under-600 {\n    display: block !important;\n  }\n\n  .feed-content {\n    margin-right: 0px !important;\n    margin-top: -50px !important;\n    padding-top: 60px !important;\n    height: 100vh !important;\n  }\n\n  .flex-wrap-under-600 {\n    flex-wrap: wrap;\n  }\n\n  .font-size-24-under-600 {\n    font-size: 24px !important;\n  }\n\n  .font-size-34-under-600 {\n    font-size: 34px !important;\n  }\n\n  .font-size-42-under-600 {\n    font-size: 42px !important;\n  }\n\n  .full-height-under-600 {\n    height: 100% !important;\n    max-height: 100% !important;\n  }\n\n  .full-width-under-600 {\n    width: 100% !important;\n  }\n\n  .full-width-minus-35-under-600 {\n    width: calc(100% - 35px) !important;\n  }\n\n  .height-under-600 {\n    height: 100vh !important;\n  }\n\n  .hide-under-600 {\n    display: none !important;\n  }\n\n  .inner-height-under-600 {\n    height: var(--inner-height) !important;\n  }\n\n  .left-margin-under-600 {\n    margin-left: 20px !important;\n  }\n\n  .margin-auto-under-600 {\n    margin: 20px auto 0 !important;\n  }\n\n  .margin-left-0-under-600 {\n    margin-left: 0px !important;\n  }\n\n  .margin-right-auto-under-600 {\n    margin-right: auto !important;\n  }\n\n  .margin-right-10-under-600 {\n    margin-right: 10px !important;\n  }\n\n  .margin-top-under-600 {\n    margin-top: 20px !important;\n  }\n\n  .margin-under-600 {\n    margin-bottom: 83px !important;\n  }\n\n  .max-width-80-under-600 {\n    max-width: 80%;\n  }\n\n  .messages {\n    height: calc(100vh - 210px) !important;\n  }\n\n  .messages-messaging {\n    height: calc(100vh - 324px) !important;\n  }\n\n  .no-margin-under-600 {\n    margin: 0px !important;\n  }\n\n  .no-margin-right-under-600 {\n    margin-right: 0px !important;\n  }\n\n  .no-padding-under-600 {\n    padding: 0px !important;\n  }\n\n  .padding-left-20-under-600 {\n    padding-left: 20px !important;\n  }\n\n  .padding-under-600 {\n    padding: 0 20px !important;\n  }\n\n  .padding-20px-under-600 {\n    padding: 20px !important;\n  }\n\n  .show-block-under-600 {\n    display: block !important;\n  }\n\n  .search-results {\n    margin-top: -20px;\n    margin-bottom: 20px;\n  }\n\n  .show-over-601 {\n    display: none !important;\n  }\n\n  .show-under-600 {\n    display: block;\n  }\n\n  .side-margins-0-under-600 {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n  }\n\n  .side-margins-20-under-600 {\n    margin-left: 20px !important;\n    margin-right: 20px !important;\n  }\n\n  .side-margins-25-under-600 {\n    margin-left: 25px !important;\n    margin-right: 25px !important;\n  }\n\n  .side-padding-0-under-600 {\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n  }\n\n  .side-padding-10-under-600 {\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n  }\n\n  .side-padding-15-under-600 {\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n  }\n\n  .side-padding-20-under-600 {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n\n  .side-padding-25-under-600 {\n    padding-left: 25px !important;\n    padding-right: 25px !important;\n  }\n\n  .spool-messages-max-width {\n    max-width: 100vw;\n  }\n\n  .text-align-center-under-600 {\n    text-align: center;\n  }\n\n  .thread-height-under-600 {\n    height: calc(var(--inner-height) - 149px - var(--top-height));\n  }\n\n  .top-under-600 {\n    top: 34px !important;\n  }\n\n  .width-70-under-600 {\n    width: 70% !important;\n  }\n\n  .width-100-under-600 {\n    width: 100% !important;\n  }\n\n  .zero-top-under-600 {\n    top: 0px !important;\n  }\n}\n\n@media only screen and (max-width: 555px) {\n  .no-margin-under-555 {\n    margin-right: 0 !important;\n  }\n}\n\n@media only screen and (max-width: 569px) {\n  .height-50-under-569 {\n    height: 50px !important;\n  }\n}\n\n@media only screen and (max-width: 450px) {\n  .padding-20-under-450 {\n    padding: 20px !important;\n  }\n}\n\n@media only screen and (min-width: 401px) {\n  .show-flex-over-401 {\n    display: flex;\n  }\n\n  .show-flex-under-400 {\n    display: none !important;\n  }\n\n  .show-under-400 {\n    display: none !important;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .border-radius-5-under-400 {\n    border-radius: 5px !important;\n  }\n\n  .carbon-background-under-400 {\n    background-color: #2a2a2a !important;\n  }\n\n  .display-block-under-400 {\n    display: block !important;\n  }\n\n  .font-size-32-under-400 {\n    font-size: 32px !important;\n  }\n\n  .font-size-30px-under-400 {\n    font-size: 30px !important;\n  }\n\n  .font-size-16px-under-400 {\n    font-size: 16px !important;\n  }\n\n  .full-width-under-400 {\n    width: 100% !important;\n  }\n\n  .hide-under-400 {\n    display: none !important;\n  }\n\n  .justify-content-center-under-400 {\n    justify-content: center;\n  }\n\n  .margin-0-under-400 {\n    margin: 0px !important;\n  }\n\n  .no-flex-under-400 {\n    display: block !important;\n  }\n\n  .reaction-text {\n    display: none;\n  }\n\n  .show-flex-over-401 {\n    display: none !important;\n  }\n\n  .show-flex-under-400 {\n    display: flex;\n  }\n\n  .side-padding-20-under-400 {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n\n  .text-align-center-under-400 {\n    text-align: center;\n  }\n}\n\n@media only screen and (max-width: 369px) {\n  .hide-under-369 {\n    display: none !important;\n  }\n\n  .width-under-369 {\n    width: calc(100% - 50px) !important;\n  }\n}\n\n@media only screen and (max-width: 350px) {\n  .no-flex-under-350 {\n    display: block !important;\n  }\n\n  .margin-bottom-under-350 {\n    margin-bottom: 15px;\n  }\n\n  .text-align-under-350 {\n    text-align: center;\n  }\n}\n","@import 'variables.less';\n\n/** Page setup **/\n@page {\n  size: auto;\n  margin: 0;\n}\n\n/** Media Queries **/\n@media print {\n  .do-not-print {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 601px) {\n  .hide-over-601 {\n    display: none !important;\n  }\n\n  .more-light-gray-background-on-hover:hover {\n    background-color: rgba(178, 178, 178, 0.15) !important;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  .border-bottom-under-800 {\n    border-bottom: 1px solid #f0f0f0;\n  }\n\n  .feed-topbar,\n  .show-block-under-800,\n  .show-flex-under-800,\n  .show-under-800 {\n    display: block !important;\n  }\n\n  .hide-under-800,\n  .show-flex-over-801,\n  .show-over-801 {\n    display: none !important;\n  }\n\n  .hide-side-margins-under-800 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .inbox-spool-container,\n  .messages-max-width,\n  .max-width-under-800,\n  .width-100-under-800 {\n    max-width: 100% !important;\n  }\n\n  .flex-column-under-800 {\n    flex-direction: column;\n  }\n\n  .font-18-under-800 {\n    font-size: 18px !important;\n  }\n\n  .margin-0-under-800,\n  .margin-left-0-under-800,\n  .margin-top-under-800,\n  .top-50-under-800 {\n    margin: 0 !important;\n    top: 50px !important;\n  }\n\n  .margin-right-20-under-800 {\n    margin-right: 20px !important;\n  }\n\n  .padding-bottom-under-800,\n  .padding-under-800 {\n    padding: 15px 20px !important;\n  }\n\n  .top-flush {\n    top: var(--top-height);\n  }\n}\n\n/** General Styles **/\n.app-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.block {\n  display: block;\n}\n\n.blue-text {\n  color: @blue;\n}\n\n.box-shadow-style {\n  box-shadow: 1px 1px 8px 0px rgba(231, 231, 231, 1);\n}\n\n.carbon-text {\n  color: @carbon;\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 18px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.column {\n  flex-direction: column;\n}\n\n.double-blue-border-on-focus {\n  border: 2px solid transparent;\n  position: relative;\n\n  &:focus-visible {\n    border: 2px solid #ffffff !important;\n    outline: 2px solid #0894cf !important;\n    outline-offset: 2px;\n    box-shadow:\n      0 0 0 2px #98e0ff,\n      0 0 0 4px #98e0ff;\n    z-index: 1;\n  }\n}\n\n.text-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.flex,\n.flex-grow,\n.flex-v-align,\n.flex-h-align,\n.flex-vh-align {\n  display: flex;\n}\n\n.flex-end {\n  justify-content: flex-end;\n}\n\n.flex-grow {\n  flex-grow: 1;\n}\n\n.flex-v-align {\n  align-items: center;\n}\n\n.flex-h-align {\n  justify-content: center;\n}\n\n.flex-vh-align {\n  align-items: center;\n  justify-content: center;\n}\n\n.gradient {\n  background: linear-gradient(to right, @gradient-start, @gradient-end);\n}\n\n.gray-on-hover {\n  cursor: pointer;\n  transition: color 0.3s ease-in-out;\n\n  &:hover {\n    color: var(--steel) !important;\n  }\n}\n\n.gray-background-on-hover {\n  cursor: pointer;\n  transition: background-color 0.3s ease-in-out;\n\n  &:hover {\n    background-color: var(--lightoffwhite) !important;\n  }\n}\n\n.light-gray-background-on-hover {\n  cursor: pointer;\n  transition: background-color 0.3s ease-in-out;\n\n  &:hover {\n    background-color: var(--lightgrey) !important;\n  }\n}\n\n.header {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 100;\n}\n\n.input-label {\n  color: @carbon;\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: 0.25px;\n}\n\n.light-blue-background-on-hover {\n  transition: background-color 0.3s ease-in-out;\n\n  &:hover {\n    background-color: #e0f3fb !important;\n  }\n}\n\n.light-blue-border-on-hover {\n    transition: border-color 0.3s ease-in-out;\n\n    &:hover {\n        border: 1px solid #0894CF !important;\n        box-shadow: 0 0px 4px 0px rgba(8, 148, 207, 1);\n    }\n}\n.thick-light-blue-border-on-hover {\n    position: relative;\n\n    &:hover {\n        /* When hovering this element specifically (not when a child with the same class is hovered) */\n        &:not(:has(.thick-light-blue-border-on-hover:hover)) {\n            border: 2px solid var(--blue) !important;\n            box-shadow: 0 0px 4px 0px rgba(8, 148, 207, 1);\n            background-color: var(--lightoffwhite);\n\n            /* Show icons only when this specific element is being hovered */\n            & > .hover-icons {\n                display: flex;\n            }\n        }\n    }\n\n    .hover-icons {\n        display: none;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        transform: translateY(-50%);\n        gap: 8px;\n    }\n}\n\n.selected {\n    border: 2px solid #0894CF !important;\n    box-shadow: 0 0px 4px 0px rgba(8, 148, 207, 1);\n\n   & > .hover-icons {\n        display: flex !important;\n    }\n}\n\n.mapboxgl-ctrl-2d {\n  background-image: url('https://s3-us-east-2.amazonaws.com/polimorphic-sha256/59422fb1d0b22010cf57ab619138a0af9687020619d2188df067515434259fb1/2d.svg');\n  background-size: cover;\n}\n\n.mapboxgl-ctrl-3d {\n  background-image: url('https://s3-us-east-2.amazonaws.com/polimorphic-sha256/d837050af2fa0bc0e4844304d69dbe8dab10b547195fd83bf93af7e683a1a791/3d.svg');\n  background-size: cover;\n}\n\n.mapboxgl-ctrl-attrib.mapboxgl-compact {\n  display: none !important;\n}\n\n.mapboxgl-ctrl-logo {\n  display: none !important;\n}\n\n.mapboxgl-ctrl-satellite {\n  background-image: url('https://s3-us-east-2.amazonaws.com/polimorphic-sha256/241018ee4ec04017e4e40d9e892ef80b24e19c73982b5a0d264cc2a1f328ece1/satellite.svg');\n  background-size: cover;\n}\n\n.mapboxgl-ctrl-street {\n  background-image: url('https://s3-us-east-2.amazonaws.com/polimorphic-sha256/ee4a715ad3d9692c9820758b4315aa3075e9feeabbafab380001bcc7e3b33593/map.svg');\n  background-size: cover;\n}\n\n.modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1001;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1300;\n}\n\n.overflow-vertical-style {\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.sidebar:hover {\n  max-width: 250px !important;\n  width: 250px !important;\n\n  .sidebar-text {\n    display: block !important;\n  }\n}\n\n.sidebar-menu-item1 {\n  border-radius: 5px;\n  cursor: pointer;\n  padding: 10px 15px;\n\n  &-icon {\n    margin-right: 15px;\n  }\n\n  &.active {\n    background-color: rgba(178, 178, 178, 0.15);\n  }\n\n  &:hover {\n    background-color: rgba(178, 178, 178, 0.15);\n  }\n}\n\n.sticky {\n  position: sticky;\n  position: -webkit-sticky;\n}\n\n.textCenter {\n  text-align: center;\n}\n\n.transitionStyle {\n  transition: 200ms ease-in;\n}\n\n.wrap {\n  flex-wrap: wrap;\n  row-gap: 16px;\n}\n\n// same as fr-view\n.styled-links a {\n  color: #0894CF;\n}\n\n.styled-links a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
